// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// Order matters: establish Rails UJS + jQuery globals BEFORE Stimulus controllers.
// ESM `import` is hoisted above `require`, so a failing controller import used to abort
// the pack before `@rails/ujs`.start() — turning every data-method link into a GET.
// Prefer require() here so startup stays strictly sequential.

const $ = require("jquery");
global.$ = $;
global.jQuery = $;

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");

require("controllers");

require("../lib/lightgallery-all");
require("../lib/direct_uploads");
require("../lib/jstz");
require("../lib/trix_customize");
require("../lib/slick");
require("../lib/select2");
